export default __webpack_public_path__ + "static/media/thumbnail.2463f016.webp";